import React from 'react';

import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from 'Containers/app/experiments/useBinaryExperiment';

import CookieWarning from '../misc/CookieWarning/CookieWarning';

import { CookieConsent } from './CookieConsent';
import { CookiePolicyReminderBanner } from './CookiePolicyReminderBanner';

export const CookieConsentExperiment = () => {
  const showConsentBanner = useBinaryExperiment(FLAG.COOKIE_CONSENT_BANNER, {
    triggerExperiment: true,
  });

  if (!showConsentBanner) {
    return <CookieWarning />;
  }

  return (
    <>
      <CookieConsent />
      <CookiePolicyReminderBanner />
    </>
  );
};
